import React from 'react';
import Energy from '/images/dashboard-page/energy.svg';
import { copyFor } from 'config';
import { Container } from 'styles';
import { StyledModule } from '../styled-module';
import { ModuleContainer } from '../impact-modules.style';
import { StyledSVG, StyledText } from './energy-production.style';

const getCopy = copyFor(
  'dashboard.standardDashboard.impactModules.energyProduction'
);

interface Props {
  vnmKwhCumulative?: number;
  vnmKwhLastStatement?: number;
}
export const EnergyProduction = ({
  vnmKwhCumulative,
  vnmKwhLastStatement,
}: Props) => {
  const placeHolder = !vnmKwhCumulative;
  const text = getCopy('emptyState');
  return !placeHolder ? (
    <StyledModule
      showBadge={!!vnmKwhLastStatement}
      title={getCopy('title')}
      tooltipProps={{
        content: getCopy('tooltip.content'),
        label: getCopy('tooltip.label'),
        tooltipId: 'EnergyProduction',
      }}
      boldCopy={getCopy('kwh', { kwh: vnmKwhCumulative })}
      svgSrc={Energy}
      badgeCopy={getCopy('badge', { kwh: vnmKwhLastStatement })}
    />
  ) : (
    <ModuleContainer>
      <Container
        height="100%"
        flex
        justifyContent="space-between"
        alignItems="center"
        small={{
          alignItems: 'flex-start',
          direction: 'column-reverse',
          justifyContent: 'start',
          gap: '10px',
        }}
      >
        <StyledText color="secondary" textStyle="paragraph400">
          {text}
        </StyledText>
        <StyledSVG src={Energy} aria-hidden={true} />
      </Container>
    </ModuleContainer>
  );
};
